export const HANDOFF = 'HANDOFF';
export const HANDOFF_BUSY = 'HANDOFF_BUSY';
export const HANDOFF_SUCCESS = 'HANDOFF_SUCCESS';
export const HANDOFF_ERROR = 'HANDOFF_ERROR';
export const HANDOFF_TIMEOUT = 'HANDOFF_TIMEOUT';
export const HANDOFF_MODAL_CLOSE = 'HANDOFF_MODAL_CLOSE';
export const HANDOFF_RETRY = 'HANDOFF_RETRY';
export const HANDOFF_UPDATE_KIOSK_CART = 'HANDOFF_UPDATE_KIOSK_CART';
export const HANDOFF_RESET_KIOSK_CART = 'HANDOFF_RESET_KIOSK_CART';
